import type { AuthService } from './auth-service.port';

let authService: AuthService | null = null;

/**
 * Set the AuthService implementation.
 * Must be called before any auth operations.
 */
export function setAuthService(service: AuthService): void {
  authService = service;
}

/**
 * Get the AuthService implementation.
 * @throws Error if setAuthService was not called first.
 */
export function getAuthService(): AuthService {
  if (!authService) {
    throw new Error('AuthService not initialized. Call setAuthService() first.');
  }
  return authService;
}

/**
 * Reset the AuthService. Used for testing.
 */
export function resetAuthService(): void {
  authService = null;
}
